import { render } from "./Page.vue?vue&type=template&id=e55e9646&scoped=true"
import script from "./Page.vue?vue&type=script&lang=js"
export * from "./Page.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-e55e9646"

export default script